import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { TEMPLATE_BASE64 } from '@/lib/templates-base64/DMDVT';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: () => void;
  onWatchIconClick: () => void;
  onRefreshClick?: () => Promise<void>;
  onImportExcel?: () => void;
  onExportExcel?: () => void;
  isEditDisabled?: boolean;
  isViewDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isCopyDisabled?: boolean;
}

const ActionBar: React.FC<ActionBarProps> = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onRefreshClick,
  onImportExcel,
  onExportExcel,
  isEditDisabled = false,
  isViewDisabled = false,
  isDeleteDisabled = false,
  isCopyDisabled = false
}) => {
  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(TEMPLATE_BASE64, 'Danh mục đơn vị tính.xlsx');
  };

  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục đơn vị tính</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteIconClick} disabled={isDeleteDisabled} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyIconClick} disabled={isCopyDisabled} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} disabled={isViewDisabled} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportExcel,
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ tập tin',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcel,
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
